var Marionette = require('marionette'),
     $ = require('jquery'),
    Backbone = require('backbone'),
    FTLayout = require('./layout/layout'),
    Radio = require('backbone.radio'),
    SubApp = require('../common/SubApp'),
    FTState = require('./layout/state'), //should be need here -- only on main view
    fvChannel = require('glRadio').channel('FV'),
    FTModel = require('./esModel/elasticSearchModel'),
    ResetView = require('../common/resetPlaceholder/resetPlaceholder');

require('extendBackbone');
require('backboneFwd');
require('jqCheckInView');
require('jqCenteredScroll');

var instanceVars = {
    region: null,
    layout: null,
    fullTextModel: null, //note: (stored on the document model -- the 'activeDocument' )
    channel: null, //(from subapp)
    vChannel: null,
    state: null //note: now storing options, those should prob be moved into own obj with defaults, etc ...
};

module.exports = SubApp.extend({
    constructor: function(options, id) {
        
        _.extend(this, instanceVars, _.pick(options, 'fullTextModel', 'vChannel'), {
            id: id,
            region: new Marionette.Region({
                el: options.$container
            }),
            state: options.state ? 
                options.state 
                : new FTState( _.extend( {},
                    _.pick(options, FTState.prototype.getArrayOfAttributesToPersist() ) //limit any unwanted from moduleWr change options provided
                 ))
        });

        SubApp.prototype.constructor.apply(this, arguments);

        /* exported events -- where listener is set -- see viewer channel subscription callbacks */
        Backbone.fwd.call(this.vChannel, this.channel);

        /* IE8 needs the viewer to be visible in the DOM to calc the correct page offsets */
        //TODO: for module only -- also need listener for this being rendered
        if (fvChannel.request('settings').isIE8) {
            this.listenTo(this.vChannel, 'vChannel:region:viewerVisible', _.bind(function () { //TODO: fwd from subscriptions & above
                this.channel.command('calcPageBottoms');
            }, this));
        }
    },
    commands: {
        render: function(cb) {

            //TODO: ISSUE IF RE-RENDER AND PAGE COLLECTION EXISTS, WANT THE MIN OF THAT IN THE PAGE -- perhaps page text collection s/d be first

            /* don't allow current page (if set by param) to be greater than the number of pages in the document */

            //TODO: if document has no pages (eg if a folder), this.fullTextModel.numberOfPgsInDoc() will be 0, resulting in NaN -- this may not couse a problem
           this.state.set( 'currentPg', Math.min( this.state.get('currentPg'), this.fullTextModel.numberOfPgsInDoc() ), {
               silent: true
           } );

            this.layout = new FTLayout({
                model: this.fullTextModel, /* flag here is currently preset whether error fetch url or not */
                lCh: this.channel,
                state: this.state
            });

            this.region.show( this.layout, {
                cb: cb  //(for standalone) ... note, layout has OWN show, this extends it to onAfter (optional)
            } );

        },
        showLoadingView: function() {
            //note: now called only b/f fetch specifically, could hook into model onAfterFetch for this (in viewer nothing shown until loaded entirely)
            this.region.show( new ResetView() );
        },
        changePage: function(options) { /* the only outer -- vChannel (EXPORT)*/

            // Don't allow is an error occurred on model fetch; pgTextCollection will be null
            if ( this.fullTextModel.errorOccurredOnFetch() )
                return;

            var goToPgNum = options.pageNum;

            //if in grep mode, (not all pages may be present) -- could also be applicable to upcoming metadata
            //TODO: pg text collection ... s/b top level
            if ( !this.layout.pgTextCollection.hasPageNumber(goToPgNum) )
                return;

            //TODO: note now can be from independent calling app (here will refer to as viewer)
            this.state.set('currentPg', goToPgNum, {fromViewer: true});

        },
        //TODO: now export ... but change anyway ... to not be tied to the ft model --- !
        resetSearch: function(searchTxt, sumbitIfSearchTextIsTheSame) {

            //quick validation (keyup or ok click)
            if ( !sumbitIfSearchTextIsTheSame && (searchTxt === this.fullTextModel.searchText) ) return false;

            //TODO: rid fetchurl jqXHR
            var opts = _.pick(this.fullTextModel, 'docId', 'fetchUrl', 'firstQueryRequest');

            var newFtModel = new FTModel([], {
                searchText: searchTxt,
                docId: opts.docId,
                fetchUrl: opts.fetchUrl
            });

            //TODO: make fn on state returning this
            var newState = this.state.clone();
            //don't want every state attribute cloned pre re-entry ...
            newState.set( _.pick( newState.defaults, 'activeHitNumber', 'currentPg', 'lastScrollTop'), {silent: true} );

            var self = this;
            this.command('showLoadingView'); //todo: now only here and in independent module ... combo with overall workflow

            newFtModel.fetch().done( function() {

                self.destroy();
                self.constructor({
                    fullTextModel: newFtModel,
                    vChannel: self.vChannel,
                    $container: self.options.$container,
                    channel: self.channel, //use the same channel
                    state: newState
                }, self.id);

                self.channel.trigger('fullText:updateNoteCountAndCaption', newFtModel.getNumberOfHits(), newFtModel.getSearchTxt() );

                self.channel.command('render');
                //todo: working except now some minor mem leaks -- destroy on just widget has no leaks now ... appears could be the action 'research' toolbar


            }).fail(function(jqXHR) {
                //TODO: TEST ERR --- should just use build in error view, this not needed
                self.options.vChannel.command('ajaxError', jqXHR, 'Unable to make full text search request.  Cannot fetch databases.');
            });

            //fixed overwritten option but now some leaks

        },
        'vChannel:setScrollPosition': function(scrollRatio) {
            this.channel.command('setScrollPosition', scrollRatio);
        }

    },
    requests: {
        'vChannel:scrollTopRatio': function() {
            return this.channel.request('scrollPositionRatio');
        },
        getStateAttributesToPersistOnReset: function() {
            return this.state.getAttributesToPersistOnReset(); //TODO: HERE INCLUDE THE ATTR TO PERSIST
        }
    },
    onBeforeDestroy: function() {
        this.fullTextModel.abortAjaxRequests(); //(also necessary to prevent fetch dfd from completing, so render not called on module that no longer exists on module switch)
        this.state.destroy(); //!must do b/f cleaning the view b/c it hold $hits in it
        this.vChannel.stopListening();
        this.region.empty(); //onBefore destroy of layout view clears out much
    }
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/fulltext/module.js
 ** module id = 523
 ** module chunks = 0
 **/